module.exports = __webpack_public_path__ + "img/library.a37448c0.png";